module.exports = __webpack_public_path__ + "static/media/plus.6d10f931.png";